/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.28",
    versionName: "0.2.0-nightly.2026.2.28",
    versionChannel: "nightly",
    buildDate: "2026-02-28T00:10:27.866Z",
    commitHash: "473569b899d95ce3c2308de49208efb35da7018b",
};
